import { isValid, parseISO } from 'date-fns'

type SortType = 'ASC' | 'DSC'

function useDateUtils() {
  function sortDates(dates: Date[], sortType: SortType) {
    switch (sortType) {
      case 'ASC': {
        return dates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      }
      case 'DSC': {
        return dates.sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
      }
    }
  }

  function getUniqueDates(dates: Date[]) {
    return Array.from(new Set(dates.map((date) => date.toISOString())))
  }

  function safeParseISO(value: string): Date | undefined {
    const date = parseISO(value)
    return isValid(date) ? date : undefined
  }

  return {
    sortDates,
    getUniqueDates,
    safeParseISO
  }
}

export default useDateUtils
